
// constants as defined in RevoXef’s App\Models\Menu\MenuMenuCategory
const NO_CHOICE = 0
const CHOICE = 1
const NO_CHOICE_MANDATORY = 2
const SELECT_DEFAULT = 3
const SELECT_DYNAMIC = 4


export default {
  NO_CHOICE,
  CHOICE,
  NO_CHOICE_MANDATORY,
  SELECT_DEFAULT,
  SELECT_DYNAMIC,
  min: o => {
    switch (o.isMultipleChoice) {
      case NO_CHOICE: return 0
      case CHOICE: return 0
      case NO_CHOICE_MANDATORY: return 1
      case SELECT_DEFAULT: return 0
      case SELECT_DYNAMIC: return o.min
    }
  },
  max: o => {
    switch (o.isMultipleChoice) {
      case NO_CHOICE: return 1
      case CHOICE: return 100
      case NO_CHOICE_MANDATORY: return 1
      case SELECT_DEFAULT: return 100
      case SELECT_DYNAMIC: return o.max
    }
  },
}
